import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {OfflineMapSummaryApiService} from '../../../services/offline-map/offline-map-summary-api/offline-map-summary-api.service';
import {OfflineMapService} from '../../../services/map/offline-map/offline-map.service';

@Component({
  selector: 'offline-nothing-selected-summary',
  templateUrl: './offline-nothing-selected-summary.component.html',
  styleUrls: ['./offline-nothing-selected-summary.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class OfflineNothingSelectedSummaryComponent implements OnInit, OnDestroy {

  constructor(private offlineMapSummaryApi: OfflineMapSummaryApiService,
              private offlineMapService: OfflineMapService) {}

  nodesTotal: any;
  nodesDistribution: any;
  peerConnectionsTotal: any;
  peerConnectionsDistribution: any;
  connectionsTotal: any;
  connectionsDistribution: any;
  dataReady = false;
  summaryRefreshObservable;

  ngOnInit(): void {
    this.initializeDevicesStatusStatistics();

    this.summaryRefreshObservable = this.offlineMapService.onRefreshSummary().subscribe(() => {
      this.initializeDevicesStatusStatistics();
    });
  }

  private initializeDevicesStatusStatistics(): void {
    this.offlineMapSummaryApi.getNodesTotal((fetchedNodesTotalDistribution) => {
      this.nodesTotal = fetchedNodesTotalDistribution;
    });
    this.offlineMapSummaryApi.getNodesDistribution((fetchedNodesDistribution) => {
      this.nodesDistribution = fetchedNodesDistribution;
    });
    this.offlineMapSummaryApi.getPeerConnectionsTotal((fetchedTotalPeerConnections) => {
      this.peerConnectionsTotal = fetchedTotalPeerConnections;
    });
    this.offlineMapSummaryApi.getPeerConnectionsDistribution((fetchedPeerConnectionsDistribution) => {
      this.peerConnectionsDistribution = fetchedPeerConnectionsDistribution;
    });
    this.offlineMapSummaryApi.getConnectionsTotal((fetchedTotalConnections) => {
      this.connectionsTotal = fetchedTotalConnections;
    });
    this.offlineMapSummaryApi.getConnectionsDistribution((fetchedConnectionsDistribution) => {
      this.connectionsDistribution = fetchedConnectionsDistribution;
    });
  }

  ngOnDestroy(): void {
    this.summaryRefreshObservable.unsubscribe();
  }

}
